import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function YearlyDefectRateRateKpi (props){

    const table = "VwDefectRateYearly";
    const view = "VwDefectRateYearly";

    const { filterValue, onFilterInitialized, onSearchInitialized, onModifyViewSchema } = props;

    const [ api, setApi ] = useState ( null );

    useEffect ( () => {

        if ( api ) {

            api.refresh ();

        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ api ] );


    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    return (
    
        <BasicCrudScreenType
            id="YearlyDefectRateRateKpi"
            noHeader
            table={table}
            view={view}
            extFilterValue={filterValue}
            onFilterInitialized={onFilterInitialized}
            onSearchInitialized={onSearchInitialized}
            onModifyViewSchema={onModifyViewSchema}
            onApiInitialized={onApiInitialized}
        />

    );

}
export default YearlyDefectRateRateKpi;